import ReactPixel from 'react-facebook-pixel';

const FBPixel = ({ id }) => {
    ReactPixel.init(id, {}, {autoConfig: true, debug: false});
    ReactPixel.pageView();
};

export default FBPixel;